import { isHiddenAuthFrame, runAuthBridge } from './auth-bridge';

/*
  Two very different pages share this entry (auth-bridge.ts explains why).

  One is the hidden iframe MSAL opens for a silent token: back from the tenant
  with an answer in its URL, it must announce that answer to the window that
  opened it and nothing more. Booting the portal here would start a second MSAL
  in the frame, race the answer, and load a whole application into a frame
  nobody sees — which is what happened until 2026-09-02, and why every silent
  sign-in timed out.

  The other is every ordinary load, which is the portal. It is imported on
  demand so that the bridge path never even downloads it.
*/
if (isHiddenAuthFrame()) {
  void runAuthBridge().catch((err: unknown) => {
    // Nobody sees a hidden frame; the console is the only place this can go.
    console.error('[auth-bridge]', err instanceof Error ? err.message : String(err));
  });
} else {
  void import('./boot');
}
